import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4c20a75e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "news-container" }
const _hoisted_2 = { class: "news-header" }
const _hoisted_3 = { class: "news-header-title text-ellipsis" }
const _hoisted_4 = { class: "news-list-container" }
const _hoisted_5 = { style: {"display":"flex","flex-wrap":"wrap"} }
const _hoisted_6 = ["onClick"]

import {onMounted, PropType, ref} from "vue";
import {AppConfigComponent} from "@/model/AppConfig";
import {InfiniteScrollWay} from "@/views/appconfig/drawer/InfiniteScrollWay";
import JPagination from "@/components/JPagination/index.vue";
import {UIHandleGet} from "@/views/utils";
import appConfigAPI from "@/api/AppConfigAPI";
import {AppConfigGlobalMenu, AppConfigGlobalMenuModule} from "@/model/AppConfigGlobalMenu";
import JTabsContent from "@/components/JTabs/JTabsContent.vue";
import AppConfigComponentDrawerNewsList from "@/views/appconfig/drawer/AppConfigComponentDrawerNewsList.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'AppConfigComponentDrawerNews',
  props: {
  component: {
    type: Object as PropType<AppConfigComponent>,
    required: true
  }
},
  setup(__props) {

const props = __props



const globalMenus = ref<AppConfigGlobalMenu[]>([])
const activeName = ref<string>("")
const requestGlobalNewsSections = async () => {
  try {
    globalMenus.value = await UIHandleGet(appConfigAPI.globalMenus(AppConfigGlobalMenuModule.News))
    if (globalMenus.value.length > 0) {
      activeName.value = globalMenus.value[0].id!
    }
  } catch (e) {
    console.error(e)
  }
}

onMounted(async () => {
  await requestGlobalNewsSections()
})


return (_ctx: any,_cache: any) => {
  const _component_el_divider = _resolveComponent("el-divider")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, _toDisplayString(__props.component.news?.name), 1)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(globalMenus.value, (item) => {
          return (_openBlock(), _createElementBlock("div", {
            onClick: ($event: any) => (activeName.value = item.id!),
            class: _normalizeClass([{'active': item.id === activeName.value}, "item"])
          }, _toDisplayString(item.name), 11, _hoisted_6))
        }), 256))
      ]),
      _createVNode(_component_el_divider, {
        "border-style": "dashed",
        style: {"margin":"0"}
      }),
      _createElementVNode("div", null, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(globalMenus.value, (item) => {
          return (_openBlock(), _createBlock(JTabsContent, {
            value: item.id,
            "active-value": activeName.value
          }, {
            default: _withCtx(() => [
              (item.newsSectionId)
                ? (_openBlock(), _createBlock(AppConfigComponentDrawerNewsList, {
                    key: item.id,
                    style: {"min-height":"300px"},
                    sectionId: item.newsSectionId
                  }, null, 8, ["sectionId"]))
                : _createCommentVNode("", true)
            ]),
            _: 2
          }, 1032, ["value", "active-value"]))
        }), 256))
      ])
    ])
  ]))
}
}

})